import {
  AiSummaryRequestData,
  SolutionCubeSideData,
  UseSolutionCategoryPageDataArgs,
  UseSolutionCategoryPageDataReturn,
} from "./types";
import {
  filterDynamicTestSetsByEntriesSession,
  filterEntriesByModule,
  filterTestSets,
  groupTestSetsByCubeSide,
} from "../../utils";
import { Module } from "../../../../../constants";
import { CUBE_SIDE_NAMES } from "./../../components/Сube/constants";
import { filterDynamicTestSetsByCategoryAndSide } from "../useReflectionCategoryPageData/utils";
import { buildSolutionCubeSideData } from "./utils";
import { useSolutionJourney } from "./useSolutionJourney";

export function useSolutionCategoryPageData({
  category,
  rawData,
  selectedFilters,
  currentTestId,
}: UseSolutionCategoryPageDataArgs): UseSolutionCategoryPageDataReturn {
  const entries = rawData?.allEntries ?? [];
  const dynamicTestSets = rawData?.dynamicTestSets ?? [];
  const testSets = rawData?.testSets ?? [];
  const solutionJourney = useSolutionJourney({ testSets, currentTestId });

  const solutionEntries = filterEntriesByModule(
    entries,
    Module.Solution,
    selectedFilters
  );

  const solutionDynamicTestSets = filterDynamicTestSetsByEntriesSession(
    dynamicTestSets,
    solutionEntries,
    Module.Solution
  );

  const categoryTestSets = filterTestSets(testSets, {
    category,
  });
  const currentTestAndCategoryTestSets = filterTestSets(categoryTestSets, {
    testId: currentTestId,
  });
  const categoryTestSetIds = categoryTestSets.map(ts => ts._id);
  const testSetsByCubeSide = groupTestSetsByCubeSide(
    currentTestAndCategoryTestSets
  );

  const cubeSidesData = CUBE_SIDE_NAMES.reduce((acc, cubeSide) => {
    const dynamicTestSetsForSide = filterDynamicTestSetsByCategoryAndSide(
      solutionDynamicTestSets,
      cubeSide,
      categoryTestSetIds
    );

    acc[cubeSide] = buildSolutionCubeSideData(
      solutionEntries,
      cubeSide,
      testSetsByCubeSide[cubeSide]?.[0],
      dynamicTestSetsForSide
    );

    return acc;
  }, {} as SolutionCubeSideData);

  const aiSummaryRequestData = CUBE_SIDE_NAMES.reduce((acc, cubeSide) => {
    const entriesIds = solutionEntries
      .filter(
        e =>
          cubeSidesData[cubeSide]?.dynamicTestSetsForSide.some(
            dts => dts._id === e.testSetId
          )
      )
      .map(e => e._id);

    acc[cubeSide] = {
      entriesIds,
      testSetId: testSetsByCubeSide[cubeSide]?.[0]?._id || "",
    };
    return acc;
  }, {} as AiSummaryRequestData);

  return {
    cubeSidesData,
    solutionJourney,
    aiSummaryRequestData,
  };
}
